module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": ""
    }
  }, [(_vm.intents.length === 0) ? _c('div', {
    staticClass: "text-xs-center pt-2 pb-2 grey--text text--darken-1"
  }, [_vm._v("No results")]) : [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.intents), function(item, index) {
    return _c('v-list-group', {
      key: item.Code
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "avatar": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {}
      },
      slot: "item"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(item.ShortDescription))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.Scopes))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
      key: item.Description,
      on: {
        "click": function($event) {
          _vm.details(item, index)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "grey--text text--darken-4"
    }, [_vm._v(_vm._s(item.Description))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_c('a', {
      staticClass: "nostyle",
      attrs: {
        "target": "_blank",
        "href": _vm.itemUrl(item)
      }
    }, [_vm._v("\n                                            " + _vm._s(item.Code) + "\n                                        ")])])], 1)], 1)], 1)
  }))], 1)], 1)], 1)], _vm._v(" "), _c('v-btn', {
    attrs: {
      "absolute": "",
      "dark": "",
      "fab": "",
      "bottom": "",
      "right": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61c0d909","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Intents.vue
// module id = 393
// module chunks = 0